import PollView from './PollView';
import container from './PollView.container';

export default container(PollView);
